import { HIDE_MODAL as type, HIDE_ALL_MODALS } from './';

export default (payload, all) =>
  all ? { type: HIDE_ALL_MODALS } : { type, payload };
